import { pipe, toPairs, filter, prop, test, replace, fromPairs, map } from 'ramda'

import type { Request } from '../index'

type ReportsEnabled = {
  food_cabinet_accounting_report_enabled: boolean // учет выдачи доступен
  food_cabinet_balances_report_enabled: boolean // остаток средств доступен
  food_cabinet_corrections_report_enabled: boolean // продажи по способу расчета
  food_cabinet_purchases_by_funds_report_enabled: boolean // продажи по видам средств
  food_cabinet_purchases_by_group_complexes_2_report_enabled: boolean //
  food_cabinet_purchases_by_payment_mode_report_enabled: boolean // продажи по способу расчета
  food_cabinet_sales_report_enabled: boolean // продажи доступны
  food_cabinet_subsidies_report_enabled: boolean // дотации доступны
  food_cabinet_orders_by_classes_report_enabled: boolean // учет количества питающихся по поставщикам
  food_cabinet_finances_summary_report_enabled: boolean // учет количества питающихся по поставщикам
  food_cabinet_average_check_report_enabled: boolean // средний чек
  // Finances Reposts
  food_cabinet_encashment_report_enabled: boolean // финансы - инкассация доступен
  food_cabinet_finances_e_money_legacy_report_enabled: boolean
  food_cabinet_finances_e_money_report_enabled: boolean
  food_cabinet_finances_by_sale_types_report_enabled: boolean
  food_cabinet_cafeteria_cash_report_enabled: boolean
  food_cabinet_finances_e_money_sales_report_enabled: boolean
  // Desktop Reports
  desktop_client_daily_distribution_report_enabled: boolean
  desktop_client_daily_orders_report_enabled: boolean
  desktop_client_daily_sales_report_enabled: boolean
  desktop_client_funds_sales_report_enabled: boolean
  desktop_client_payment_mode_sales_report_enabled: boolean
  desktop_client_day_by_sale_type_report_enabled: boolean
  desktop_client_day_cash_report_enabled: boolean
}

type ReportsUse = {
  food_cabinet_accounting_report_use: boolean // учет выдачи используется
  food_cabinet_balances_report_use: boolean // остаток средств используется
  food_cabinet_corrections_report_use: boolean // продажи по способу расчета
  food_cabinet_purchases_by_funds_report_use: boolean // продажи по видам средств
  food_cabinet_purchases_by_group_complexes_2_report_use: boolean //
  food_cabinet_purchases_by_payment_mode_report_use: boolean // продажи по способу расчета
  food_cabinet_sales_report_use: boolean // продажи используются
  food_cabinet_subsidies_report_use: boolean // дотации используются
  food_cabinet_orders_by_classes_report_use: boolean // учет количества питающихся по поставщикам
  food_cabinet_finances_summary_report_use: boolean // учет количества питающихся по поставщикам
  food_cabinet_average_check_report_use: boolean // средний чек
  // Finances Reposts
  food_cabinet_encashment_report_use: boolean //  финансы - инкассация используется
  food_cabinet_finances_e_money_legacy_report_use: boolean
  food_cabinet_finances_e_money_report_use: boolean
  food_cabinet_finances_by_sale_types_report_use: boolean
  food_cabinet_cafeteria_cash_report_use: boolean
  food_cabinet_finances_e_money_sales_report_use: boolean
  // Desktop Reports
  desktop_client_daily_distribution_report_use: boolean
  desktop_client_daily_orders_report_use: boolean
  desktop_client_daily_sales_report_use: boolean
  desktop_client_funds_sales_report_use: boolean
  desktop_client_payment_mode_sales_report_use: boolean
  desktop_client_day_by_sale_type_report_use: boolean
  desktop_client_day_cash_report_use: boolean
}

export type ReportsListResult = ReportsEnabled & ReportsUse

export const GET_REPORTS_LIST: Request<void, ReportsListResult, void> = [
  'food/reports_list',
  'get',
  ['data', 'reports'],
]

export type MutableParams = Partial<ReportsUse>

export const defaultMutableParams: MutableParams = {
  food_cabinet_accounting_report_use: false,
  food_cabinet_balances_report_use: false,
  food_cabinet_corrections_report_use: false,
  food_cabinet_purchases_by_funds_report_use: false,
  food_cabinet_purchases_by_group_complexes_2_report_use: false,
  food_cabinet_purchases_by_payment_mode_report_use: false,
  food_cabinet_sales_report_use: false,
  food_cabinet_subsidies_report_use: false,
  food_cabinet_orders_by_classes_report_use: false,
  food_cabinet_finances_summary_report_use: false,
  food_cabinet_average_check_report_use: false,

  food_cabinet_encashment_report_use: false,
  food_cabinet_finances_e_money_legacy_report_use: false,
  food_cabinet_finances_e_money_report_use: false,
  food_cabinet_finances_by_sale_types_report_use: false,
  food_cabinet_cafeteria_cash_report_use: false,
  food_cabinet_finances_e_money_sales_report_use: false,

  desktop_client_daily_distribution_report_use: false,
  desktop_client_daily_orders_report_use: false,
  desktop_client_daily_sales_report_use: false,
  desktop_client_funds_sales_report_use: false,
  desktop_client_payment_mode_sales_report_use: false,
  desktop_client_day_by_sale_type_report_use: false,
  desktop_client_day_cash_report_use: false,
}

type PostReportsListParams = {
  reports: MutableParams
}

export const POST_REPORTS_LIST: Request<PostReportsListParams, ReportsListResult, void> = [
  'food/reports_list',
  'post',
  ['data', 'reports'],
]

export const onlyMutableParams: (ReportsListResult) => MutableParams = pipe(
  toPairs,
  filter(pipe(prop(0), test(/_report_use$/))),
  fromPairs,
)

export const onlyMutableAndEnabledParams = (params: ReportsListResult): MutableParams =>
  pipe(
    toPairs,
    filter<any>(
      ([key]) =>
        test(/_report_use$/, key) && params[replace(/_report_use$/, '_report_enabled', key)],
    ),
    fromPairs,
  )(params)

export const onlyAvailableReports = (params: ReportsListResult): Array<string> =>
  pipe(
    toPairs,
    filter(
      ([key, value]) =>
        test(/_report_use$/, key) &&
        value &&
        params[replace(/_report_use$/, '_report_enabled', key)],
    ),
    map(pipe(prop(0), replace(/^food_cabinet_/, ''), replace(/_report_use$/, ''))),
  )(params)
